import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { formValueSelector } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import Button from 'react-bootstrap/lib/Button';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import cx from 'classnames';
// import Scroll from 'react-scroll';

import Photos from '../../components/ViewListing/Photos';
import ListingIntro from '../../components/ViewListing/ListingIntro';
import Calendar from '../../components/ViewListing/Calendar';
import ListingDetails from '../../components/ViewListing/ListingDetails';
import Reviews from '../../components/ViewListing/Reviews';
import HostDetail from '../../components/ViewListing/HostDetail';
import LocationMap from '../../components/ViewListing/LocationMap';
import Loader from '../../components/Loader';
import NotFound from '../notFound/NotFound';
import AvailabilityCalendar from '../../components/ViewListing/AvailabilityCalendar';
import StarRating from '../../components/StarRating';
import CurrencyConverter from '../../components/CurrencyConverter';
import BookingModal from '../../components/ViewListing/BookingModal';
import SimilarListings from '../../components/ViewListing/SimilarListings';
import HostDetails from '../../components/ViewListing/HostDetails';

import BlockedDatesQuery from './BlockedDates.graphql';
import ListingDataQuery from './getListingData.graphql';
import MoreReviewsQuery from './MoreReviews.graphql';
import SimilarListsQuery from './getSimilarListing.graphql';

import messages from '../../locale/messages';
import { openBookingModal } from '../../actions/BookingModal/modalActions';
import { withQuery } from '../../hoc/withGraphql';

import { CommonThunderBoltIcon } from '../../components/Common/Assets/SvgComponent/commonSvgIcon';
import s from './ViewListing.css';
import bt from '../../components/commonStyle.css';


import { Link, Scroll, Element } from 'react-scroll';
// Or Access Link,Element,etc as follows
// const  Link = Scroll.Link;
// const  Element = Scroll.Element;
const selector = formValueSelector('BookingForm');

const ViewListing = ({
  ListingBlockedDates,
  listReviewsData,
  baseCurrency,
  listId, title,
  getListingData: { loading, UserListing },
  preview, startDate,
  endDate, guests,
  similarListsData,
  similarListsData: { getSimilarListing }, lat, lng }) => {

  const containerRef = useRef(null);
  const dispatch = useDispatch();

  const account = useSelector(state => state.account.data);
  const isAdmin = useSelector(state => state.runtime.isAdminAuthenticated);
  const averageBasePrice = useSelector(state => selector(state, 'averageBasePrice'));

  const [isAutoAffixInViewport, setIsAutoAffixInViewport] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => {
      window.removeEventListener('scroll', handleScroll);
    }

  }, [])


  const topViewport = () => {
    const container = containerRef?.current;
    if (container) {
      const rect = container.getBoundingClientRect();
      return rect.top;
    }
  };

  const handleScroll = () => {
    const topViewPort = topViewport();
    const isAutoAffixInViewport = topViewPort <= 0;
    setIsAutoAffixInViewport(isAutoAffixInViewport);
  };

  let scrollAffixClass, basePriceValue, currencyValue, isHost;
  let reviewsStarRating, reviewsCount, starRatingValue = 0;;

  scrollAffixClass = isAutoAffixInViewport ? s.activeStickyBar : s.nonActiveStickyBar;

  const userId = account?.userId;
  const userBanStatus = account?.userBanStatus;
  const isBrowser = typeof window !== 'undefined';
  const smallDevice = isBrowser ? window.matchMedia('(max-width: 640px)').matches : undefined;

  basePriceValue = UserListing?.listingData?.basePrice ? UserListing?.listingData?.basePrice : 0;
  currencyValue = UserListing?.listingData?.currency ? UserListing?.listingData?.currency : "USD";

  if (loading && !UserListing) {
    return (
      <div className={cx(s.loaderMobileView, s.viewListingLoder)}>
        <Loader type="text" />
      </div>
    )
  }
  isHost = false;
  if (UserListing) {
    if ((userId && userId === UserListing.userId) || isAdmin) {
      isHost = true;
    }
  }
  if ((preview && !isHost) || (!loading && !UserListing)) {
    return <NotFound title={title} />
  }

  reviewsCount = UserListing?.reviewsCount;
  reviewsStarRating = UserListing?.reviewsStarRating;

  if (reviewsCount > 0 && reviewsStarRating > 0) {
    starRatingValue = Math.round(reviewsStarRating / reviewsCount)
  }

  return (
    <div className={s.root}>
      <div className={s.container}>
        {
          UserListing && <div className={s.pageContainer}>
            <div className={s.pageContent}>
              <HostDetails data={UserListing}
                reviewsCount={UserListing.reviewsCount}
                reviewsStarRating={UserListing.reviewsStarRating}
                loading={loading}
              />
            </div>
            <div className={(s.pageContent)}>
              <Photos data={UserListing} loading={loading} />
            </div>
            <div className={cx(s.horizontalLineThrough)}>
              <Row className={cx(s.pageContent, s.gridTop, s.safariTop)}>

                <div className={scrollAffixClass} ref={containerRef}>
                  <ul className={s.scrollAffixBarListWrapper}>
                    <li>
                      <Link className={cx(s.autoAffixBarList)} activeClass={cx(s.isActiveAutoAffixBarList)} to="test1" spy={true} offset={-50} duration={800}>
                        <FormattedMessage {...messages.overview} />
                      </Link>
                    </li>
                    <li>
                      <Link className={cx(s.autoAffixBarList)} activeClass={cx(s.isActiveAutoAffixBarList)} to="test2" spy={true} offset={-80} duration={800}>
                        <FormattedMessage {...messages.reviews} />
                      </Link>
                    </li>
                    <li>
                      <Link className={cx(s.autoAffixBarList)} activeClass={cx(s.isActiveAutoAffixBarList)} to="test4" spy={true} offset={-70} duration={800}>
                        <FormattedMessage {...messages.location} />
                      </Link>
                    </li>
                    <li>
                      <Link className={cx(s.autoAffixBarList)} activeClass={cx(s.isActiveAutoAffixBarList)} to="test3" spy={true} offset={-70} duration={800}>
                        <FormattedMessage {...messages.theHost} />
                      </Link>
                    </li>
                  </ul>
                </div>
                <Col xs={12} sm={12} md={8} lg={8} >
                  <div className={isAutoAffixInViewport && s.activeStickyBarWrapper}>
                    <Element name="test1" className="element">
                      <div className={(s.listingIntroSection)}>
                        <ListingIntro data={UserListing}
                          reviewsCount={UserListing.reviewsCount}
                          reviewsStarRating={UserListing.reviewsStarRating} />
                      </div>
                      <ListingDetails
                        data={UserListing}
                        isHost={isHost}
                        userBanStatus={userBanStatus}
                        urlParameters={{ listTitle: UserListing.title, startDate, endDate, guests }}
                      />
                      <div className={'availabilityMobile'}>
                        <AvailabilityCalendar
                          listId={listId}
                          smallDevice={smallDevice}
                          loading={ListingBlockedDates.loading}
                          blockedDates={
                            ListingBlockedDates.UserListing != null ?
                              ListingBlockedDates.UserListing.blockedDates : undefined
                          }
                          listingData={UserListing.listingData || undefined}
                          country={UserListing.country}
                          queryStartDate={startDate}
                          queryEndDate={endDate}
                        />
                      </div>
                    </Element>
                    <Element name="test2" className="element">

                      <Reviews
                        reviewsCount={UserListing.reviewsCount}
                        reviewsStarRating={UserListing.reviewsStarRating}
                        data={listReviewsData}
                        listId={listId}
                      />
                    </Element>
                    <Element name="test4" className="element">
                      <LocationMap data={UserListing} />
                    </Element>
                    <Element name="test3" className="element">
                      <HostDetail
                        id={UserListing.id}
                        userId={UserListing.userId}
                        hostEmail={UserListing.user.email}
                        personCapacity={UserListing.personCapacity}
                        city={UserListing.city}
                        listingData={UserListing.listingData || undefined}
                        profile={UserListing.user.profile || undefined}
                        blockedDates={
                          ListingBlockedDates.UserListing != null ?
                            ListingBlockedDates.UserListing.blockedDates : undefined
                        }
                        isHost={isHost}
                        userBanStatus={userBanStatus}
                        country={UserListing.country}
                        urlParameters={{ listTitle: UserListing.title, startDate, endDate, guests }}
                      />
                    </Element>
                  </div>
                </Col>
                <Col xs={12} sm={12} md={4} lg={4} className={s.positionSticky}>
                  {
                    !smallDevice && !loading && <div className={cx(s.responsiveNopadding, 'hidden-xs hidden-sm')}>
                      <Calendar
                        id={UserListing.id}
                        loading={ListingBlockedDates.loading}
                        blockedDates={
                          ListingBlockedDates.UserListing != null ?
                            ListingBlockedDates.UserListing.blockedDates : undefined
                        }
                        personCapacity={UserListing.personCapacity}
                        listingData={UserListing.listingData || undefined}
                        isHost={isHost}
                        bookingType={UserListing.bookingType}
                        userBanStatus={userBanStatus}
                        startDate={startDate}
                        endDate={endDate}
                        reviewsCount={UserListing.reviewsCount}
                        reviewsStarRating={UserListing.reviewsStarRating}
                        guests={guests}
                        country={UserListing.country}
                      />

                    </div>
                  }
                  {
                    !smallDevice && loading && <div className={cx(s.webDevice, s.responsiveNopadding, 'hidden-xs hidden-sm')}>
                      <Calendar
                        id={UserListing.id}
                        loading={ListingBlockedDates.loading}
                        blockedDates={
                          ListingBlockedDates.UserListing != null ?
                            ListingBlockedDates.UserListing.blockedDates : undefined
                        }
                        personCapacity={UserListing.personCapacity}
                        listingData={UserListing.listingData || undefined}
                        isHost={isHost}
                        bookingType={UserListing.bookingType}
                        userBanStatus={userBanStatus}
                        startDate={startDate}
                        endDate={endDate}
                        reviewsCount={UserListing.reviewsCount}
                        reviewsStarRating={UserListing.reviewsStarRating}
                        guests={guests}
                        country={UserListing.country}
                      />

                    </div>
                  }
                </Col>
              </Row>
              {
                similarListsData && similarListsData.getSimilarListing && similarListsData.getSimilarListing.length > 0 &&
                <div className={cx(s.space2, s.noPaddingMobile,
                  s.pageContent, s.similarPadding)}>
                  <div className={cx(
                    s.sliderMargin, 'similarListing', s.similarPadding)}>
                    <div
                      className={cx(s.similarPaddingText)}>
                      <h2 className={cx(s.sectionTitleText)}><FormattedMessage {...messages.similarListings} /></h2>
                    </div>
                    <SimilarListings data={similarListsData.getSimilarListing} hideHeading={true} viewListingSimilarItem={'viewListingSimilarItem'} />
                  </div>
                </div>
              }
            </div>
          </div>
        }
        <div className={cx(s.stickyBookButton, 'visible-sm visible-xs')}>
          <div className={cx(s.filtersFooter)}>
            <div className={cx(s.filtersContainer)}>
              <Row className={s.footerContainer}>
                <div className={s.viewListingMobileViewBook}>
                  <div>
                    <div className={(s.bookItPriceAmount)}>
                      <div className={s.bookItPrice}>
                        <CurrencyConverter
                          from={currencyValue || baseCurrency}
                          amount={averageBasePrice ? averageBasePrice : (basePriceValue || 0)}
                          className={s.bookItPrice}
                        />
                        <span className={s.bookItNight}>{' '}/ <FormattedMessage {...messages.perNight} /></span>
                        {
                          UserListing && UserListing.bookingType === "instant" && <span>
                            <CommonThunderBoltIcon className7={s.instantIcon} />
                          </span>
                        }
                      </div>
                    </div>
                    {starRatingValue > 0 &&
                      <div className='reviewStarAlign'>
                        <StarRating className='smallStarRatingAdjust' name={'review'} value={starRatingValue} />
                        <span>{starRatingValue}</span>
                      </div>}
                  </div>

                  <BookingModal
                    id={UserListing.id}
                    loading={ListingBlockedDates.loading}
                    blockedDates={
                      ListingBlockedDates.UserListing != null ?
                        ListingBlockedDates.UserListing.blockedDates : undefined
                    }
                    personCapacity={UserListing.personCapacity}
                    listingData={UserListing.listingData || undefined}
                    isHost={isHost}
                    bookingType={UserListing.bookingType}
                    reviewsCount={UserListing.reviewsCount}
                    reviewsStarRating={UserListing.reviewsStarRating}
                    country={UserListing.country}
                    startDate={startDate}
                    endDate={endDate}
                  />
                  <Button
                    className={cx(s.btn, bt.btnPrimary)}
                    onClick={() => dispatch(openBookingModal())}
                  >
                    <FormattedMessage {...messages.bookNow} />
                  </Button>
                </div>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
}

ViewListing.propTypes = {
  title: PropTypes.string.isRequired,
  listId: PropTypes.number.isRequired,
  preview: PropTypes.bool,
  isAdmin: PropTypes.bool,
  account: PropTypes.shape({
    userId: PropTypes.string,
    userBanStatus: PropTypes.number,
  }),
  ListingBlockedDates: PropTypes.shape({
    loading: PropTypes.bool,
    UserListing: PropTypes.shape({
      blockedDates: PropTypes.array
    })
  }),
  getListingData: PropTypes.shape({
    loading: PropTypes.bool,
    UserListing: PropTypes.object
  }),
  lat: PropTypes.number.isRequired,
  lng: PropTypes.number.isRequired,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  similarListsData: PropTypes.shape({
    loading: PropTypes.bool,
    getSimilarListing: PropTypes.array
  }),
  openBookingModal: PropTypes.func,
};
ViewListing.defaultProps = {
  getListingData: {
    loading: false,
    UserListing: {
      userId: null
    }
  },
  ListingBlockedDates: {
    loading: true,
    UserListing: {
      blockedDates: []
    }
  },
  account: {
    userId: null,
    userBanStatus: 0,
  },
  isAdmin: false
}


export default compose(
  withStyles(s, bt),
  withQuery(ListingDataQuery,
    {
      name: 'getListingData',
      options: (props) => ({
        variables: {
          listId: Number(props.listId),
          preview: Boolean(props.preview),
        },
        fetchPolicy: 'network-only',
        ssr: false
      })
    }
  ),
  withQuery(BlockedDatesQuery,
    {
      name: 'ListingBlockedDates',
      options: (props) => ({
        variables: {
          listId: Number(props.listId),
          preview: Boolean(props.preview),
        },
        fetchPolicy: 'network-only',
        ssr: false
      })
    }
  ),
  withQuery(MoreReviewsQuery,
    {
      name: 'listReviewsData',
      options: (props) => ({
        variables: {
          listId: Number(props.listId),
        },
        fetchPolicy: 'network-only',
        ssr: false
      })
    }
  ),
  withQuery(SimilarListsQuery,
    {
      name: 'similarListsData',
      options: (props) => ({
        variables: {
          listId: Number(props.listId),
          lat: parseFloat(props.lat),
          lng: parseFloat(props.lng)
        },
        fetchPolicy: 'network-only',
        ssr: false
      })
    }
  )
)(ViewListing);